// extracted by mini-css-extract-plugin
module.exports = {"section":"Intro_section__FxHut","overview":"Intro_overview__S03fa","image":"Intro_image__Ngne4"};